<template>
  <div>
<!--  <div class="fill" v-show="provinceCode==='370000'">-->
<!--    <div style="cursor: pointer;color: red; margin: 0 auto; margin-top: 200px; width: 500px;font-size: 20px"-->
<!--         @click="jump1()">点击进入模拟志愿填报系统-->
<!--    </div>-->
<!--  </div>-->


    <div class="selectSub"  v-show="provinceCode==='370000'">
      <main>
        <div class="container">
          <div class="selectList">
            <div
                v-for="(item,index) in selectList"
                :key="index"
                class="select"
                @click="jump(item.id)">
              <img :src="item.img" alt="">
              <p>{{ item.text }}</p>
            </div>
          </div>

          <section class="volunteer-statement-container"><h3 class="title">数据免责声明</h3><div>
            <p style="color: red">1、模拟志愿系统不等同于官方实际的志愿填报系统，考虑到志愿填报存在诸多不确定性因素,所有数据仅供参考,不作为您填报志愿的绝对依据，敬请知晓！</p>
            <p style="color: red">2、为了达到良好的使用体验,建议考生和家长使用谷歌浏览器或搜狗浏览器</p>
            <p>3、志愿填报模拟系统一般不包含提前批数据，报考提前批考生请参考省招办或学校官网公布的信息，结合政策和自身条件进行填报。</p>
            <p>4、我们的数据与各省教育考试院发布的数据一致，由于各省市加分政策、学校官网对征集志愿数据的显示等原因，会与院校官网存在不一致情况，建议以各省考试院发布的数据为准。</p>
            <p>5、部分专业包括但不仅限于中外合作、校企合作、联合办学、定向、预科、农林、护理、软件工程等等特殊类型，分数相较普通类招生普遍偏低，故这部分专业的录取分数低于该院校投档线属于正常现象，望知悉。</p>
            <p>6、2023各省<span class="keyword">招生计划</span>的更新时间在出分后，未更新前可以去学校官网查询，或翻阅学校下发的<span class="keyword">招生计划</span>书，但最终请以省招办发行的招生计划书为准，望悉知！</p>
            <p>7、本系统提供的所有数据仅供考生填报志愿时参考使用，考生应考虑到高校招生计划的变化、高考试题的难度变化以及其它偶然因素引起的偏差，所提供的信息不作为填报志愿的绝对依据。</p></div>
          </section>
        </div>
      </main>
    </div>


  </div>
</template>

<script>
import {
  getSubjects, checkIsExist, submitSubjects, getCondition, getList, getMajorList, getCollegeList,
  sendVolunteer, getVolunteerList, sendDelVolunteer, sortList, downloadExcel, getUserProvinceCode
} from "../../../config";
  import scoreSeat from "./weiciComponent/scoreSeat"
  import cookies from 'js-cookie'

  export default {
    name: "voluntaryApply",
    data() {
      return {
        provinceCode:'',
        selectList: [
          {'img': require('../../../assets/img/fenweici.png'),'src': '/gk/weicisearch', 'text': '分位次查询','id':1},
          {'img': require('../../../assets/img/select2.png'), 'text': '提前批往年数据下载','id':2},
          {'img': require('../../../assets/img/select5.png'), 'text': '2024年招生计划下载','id':3},
          {'img': require('../../../assets/img/select4.png'), 'src': '/slectsubsys/index', 'text': '模拟填报系统','id':4},
        ]
      }
    },
    mounted() {
      this.getUserProvinceCode()
    },

    methods: {
      jump(id) {
        if (id===1){
          window.open("http://zhiyuan.gaozhaoedu.com/gk/weicisearch?t=" + cookies.get('userInfo')+"&pName="+this.provinceCode, "_blank")
        }else if (id===4){
          // alert('当前功能只在高考月份开放')
          window.open("http://zhiyuan.gaozhaoedu.com/gk/sys?t=" + cookies.get('userInfo')+"&provinceCode="+this.provinceCode, "_blank")
        }else if(id===3){
          // window.open("http://zhiyuan.gaozhaoedu.com/gk/enrollplan?t=" + cookies.get('userInfo')+"&provinceCode="+this.provinceCode, "_blank")
          window.open("https://file.gaozhao360.com/%E5%B1%B1%E4%B8%9C2024%E5%B9%B4%E6%99%AE%E9%80%9A%E7%B1%BB%E6%8B%9B%E7%94%9F%E8%AE%A1%E5%88%92V3%E7%89%88(1).xlsx", "_blank")
        }else if(id===2){
          window.open("https://file.gaozhaoedu.com/%E6%8F%90%E5%89%8D%E6%89%B9.xlsx", "_blank")
        }
      },
      //跳转
      jump1() {
        window.open("http://zhiyuan.gaozhaoedu.com/gk/sys?t=" + cookies.get('userInfo')+"&provinceCode="+this.provinceCode, "_blank")
      },

      async getUserProvinceCode() {
        let res = await getUserProvinceCode()
        if (res.status) {
          this.provinceCode = res.data
          console.log(this.provinceCode)
        }
      }
    }

  }
</script>

<style lang="scss">
  @import "../../../style/voluteerApply.scss";
  .el-dialog{
    .el-dialog__header{
      padding: 20px;
    }
    .el-dialog__body{
      padding: 20px;
    }
  }

  .el-popper.elPopover {
    button {
      border: none;
      margin: 0 5px;
      padding: 6px;
      border-radius: 4px;
      background-color: #fff;
      color: #606266;
      cursor: pointer;
    }

    button:hover {
      background-color: #409eff;
      color: #fff;
    }

    // 选中后的样式
    button.choosed {
      background-color: #409eff;
      color: #fff;
    }
  }

  .selectSub{
    padding-top: 100px;
    width: 1000px;
    margin: 0 auto;
  }
  // main
  main{
    padding-top: 20px;
    .selectList{
      display: flex;
      justify-content: space-between;
      padding: 20px 0 140px;
      .select{
        border: 1px solid #f2f2f2;
        width: 18%;
        text-align: center;
        padding: 40px 0;
        background-color: #fcfcfc;
        border-radius: 4px;
        cursor: pointer;
        img{
          width: 60px;
          margin-bottom: 10px;
        }
      }
      .select:hover{
        background-color: #f4f4f4;
        border: 1px solid #ddd;
      }
    }
  }


  .volunteer-statement-container {
    padding: 15px 20px;
    background-color: #FFF7F2;
    border: 1px dashed #FF6103;
    color: #666;
    font-size: 14px;
  }

</style>
